import { MoveQtyType, type DepotCardMovement } from "../../../../../api/wsDepotCards";

/** Движения сгруппированные по году и месяца */
export interface GroupedMovements {
    /** год */
    year: number;
    /** месяц в js-виде (c "0") */
    month: number;
    /** начало месяца */
    startMonthDate: string;
    /** конец месяца */
    endMonthDate: string;
    /**  остаток на начало месяца*/
    startMonthRemainder: number;
    /**  остаток на конец месяца*/
    endMonthRemainder: number;
    /** массив движений  */
    movements: GroupedMovementItem[];
}

/** Движение в группе {@link GroupedMovements} */
export interface GroupedMovementItem extends DepotCardMovement {
    /**
     * Id движения. \
     * Является индексом движения в массиве исходных движений, до группировки \
     * Считается уникальным в рамках всех движений всех групп по месяцам, возвращаемых {@link groupMovementsByYearAndMonth}
     */
    Id: number;
    /** сколько прибыло */
    Arrival: number;
    /** сколько убыло */
    Leave: number;
    /** Текущий остаток */
    Remainder: number;
}

/**
 *  Обработка результатов движений по карточкам СУ/УП, подсчет остатков, группировка по месяцам,
 *
 * @param movements - Массив движений по карточкам склада
 * @param sortOrder - порядок сортировки движений внутри месяца: "asc" (по умолчанию): сортировка от старых к новым, "desc": сортировка от новых к старым.
 * @returns Обьект, где ключи - годы и месяцы (YYYY-MM, значения - обьекты сгруппированых движений и остатков)
 */
export function groupMovementsByYearAndMonth(
    movements: DepotCardMovement[],
    sortOrder: "asc" | "desc" = "asc",
): Record<string, GroupedMovements> {
    movements.sort((a, b) => new Date(a.MoveDate).getTime() - new Date(b.MoveDate).getTime());

    let prevRemainder = 0;
    const grouped: Record<string, GroupedMovements> = {};

    movements.forEach((movement, index) => {
        const date = new Date(movement.MoveDate);
        const year = date.getFullYear();
        const month = date.getMonth();
        const yearMonthKey = `${year}-${month}`;

        /** определение расход-приход карточки*/
        const arrival = movement.QtyType === MoveQtyType.Arrival ? movement.Qty : 0;
        const leave = movement.QtyType === MoveQtyType.Leave ? movement.Qty : 0;
        const currentRemainder = prevRemainder + arrival - leave;

        const depotCardInfoMove: GroupedMovementItem = {
            ...movement,
            Id: index,
            Arrival: arrival,
            Leave: leave,
            Remainder: currentRemainder,
        };

        /** разбивка движений карточек по месяцам,годам */
        if (grouped[yearMonthKey] === undefined) {
            grouped[yearMonthKey] = {
                year,
                month,
                startMonthDate: new Date(Date.UTC(Number(year), Number(month), 1)).toISOString().split("T")[0],
                endMonthDate: new Date(Date.UTC(Number(year), Number(month) + 1, 0)).toISOString().split("T")[0],
                startMonthRemainder: prevRemainder,
                endMonthRemainder: currentRemainder,
                movements: [{ ...depotCardInfoMove }],
            };
        } else {
            if (sortOrder === "asc") {
                grouped[yearMonthKey].movements.push({ ...depotCardInfoMove });
            } else {
                grouped[yearMonthKey].movements.unshift({ ...depotCardInfoMove });
            }

            grouped[yearMonthKey].endMonthRemainder = currentRemainder;
        }
        prevRemainder = currentRemainder;
    });
    return grouped;
}
